"use client";

import { AboutSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedAboutSection from "../Components/GeneratedAboutSection";

const About: FC<AboutSectionProps> = (props) => {
  return <GeneratedAboutSection {...props} />;
};

export default About;
